import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { getCurrentUser } from '@vantiva-sa/homesight_humaui/Store/authStore';
import { translator } from '@vantiva-sa/homesight_humaui/Store/configStore';
import Card from './Card';
import SupportCardInfo from './SupportCardInfo';
import MobileAppCardInfo from './MobileAppCardInfo';
import AboutCardInfo from './AboutCardInfo';
import MainPage from '../../MainPage';
import useConfig from '../Hooks/useConfig';
import DataExport from './DataExport';
import './AboutPage.less';
import { hasOnlyStaffAdminPrivileges } from '../DeviceInventory/helpers';
import useServiceProvider from '../Hooks/useServiceProvider';
import {
  DiagnosticsProvider,
  NetworkTestCard,
  isDiagnosticsEnabled,
} from '../../features/diagnostics';

const AboutPage = () => {
  const trans = useSelector(translator);
  const [userConfigData, setUserConfigData] = useState(null);
  const providerid = useSelector(getCurrentUser)?.providerid;
  const useruuid = useSelector(getCurrentUser)?.useruuid;
  const { data: configData = [], isFetching: fetchingUserConfig } = useConfig({ useruuid });
  const currentUser = useSelector(getCurrentUser);
  const [providerData, fetching] = useServiceProvider({ providerid });

  useEffect(() => {
    if (configData) {
      setUserConfigData({
        email: configData?.customer_support?.email,
        contact: configData?.customer_support?.phone,
        website: configData?.customer_support?.website,
      });
    }
  }, [configData, fetchingUserConfig]);

  return (
    <MainPage hasSider={true} buttonSelected="help">
      <div className="help-page-main-container">
        <div className="help-page-container">
          <div className="help-page-header">
            <span className="help-page-title">{trans('HELP')}</span>
          </div>
        </div>
        <div className="help-page-content-container">
          <div className="help-page-card-div">
            <Card>
              <SupportCardInfo userConfigData={userConfigData} loading={fetchingUserConfig} />
            </Card>
            <Card>
              <MobileAppCardInfo providerData={providerData} loading={fetching} />
            </Card>
          </div>
          <div className="help-page-card-div">
            <Card>
              <AboutCardInfo />
            </Card>
            {hasOnlyStaffAdminPrivileges(currentUser?.permission_level) && (
              <Card>
                <DataExport />
              </Card>
            )}
          </div>
          {isDiagnosticsEnabled(configData) && (
            <DiagnosticsProvider>
              <div className="help-page-card-div">
                <Card>
                  <NetworkTestCard />
                </Card>
              </div>
            </DiagnosticsProvider>
          )}
        </div>
      </div>
    </MainPage>
  );
};

export default AboutPage;
